import { ProviderCustomFields } from '../types';
import { getCustomFieldValue } from './customFieldUtils';

const PRIMARY_CARE_SPECIALTIES = [
  'Family Medicine',
  'Family Medicine & Spine Care',
  'Family Practice',
  'Family medicine',
  'GYN',
  'GYN/Midwifery',
  'IM & Geriatrics',
  'Internal Med',
  'Internal Medicine',
  'OB/GYN',
  'OBGYN',
  'Pediactrics', // preserved typo from data source
  'Pediatrics',
  'Peds',
];

export type CanonProviderType = 'Pcp' | 'Specialist' | '';

export function getProviderTypeFromData(
  customFields: ProviderCustomFields | undefined,
  specialty: string | undefined
): CanonProviderType {
  const raw = (getCustomFieldValue(customFields, 'Provider-Type') || '')
    .toString()
    .trim()
    .toLowerCase();

  if (raw === 'pcp') return 'Pcp';
  if (raw === 'specialist' || raw === 'specialty') return 'Specialist';

  const spec = (specialty || '').toLowerCase();
  if (!spec) return '';
  const isPrimary = PRIMARY_CARE_SPECIALTIES.some(
    (s) => s.toLowerCase() === spec
  );
  return isPrimary ? 'Pcp' : 'Specialist';
}